import React, { useEffect } from "react";
import { Container, Tab, Tabs, Card, CardBody } from "react-bootstrap";
import ActiveSessions from 'pages/dashboard/components/active_sessions/ActiveSessions';
import SessionsHistory from 'pages/dashboard/components/SessionsHistory';

const Sessions = props => (
    <Container>
        <h1>Sessions</h1>
        <hr/>
        <Tabs
            defaultActiveKey="active"
            className="mb-3"
            >
            <Tab eventKey="active" title="Active">
                <Card>
                    <CardBody>
                        <ActiveSessions/>
                    </CardBody>
                </Card>
            </Tab>
            <Tab eventKey="history" title="History">
                <Card>
                    <CardBody>
                        <SessionsHistory/>
                    </CardBody>
                </Card>
            </Tab>
        </Tabs>
    </Container>
);

export default Sessions;
